/**
 * Copyright © Veeam Software Group GmbH.
 */

import { baseConfig } from './base.config';
import { PortalUserRoles } from '../../../entries/portal-user/enums';
import { ConfigSectionIds, ConfigStates } from '../enums';

import type { BaseUserConfig } from '../interfaces';

export const localAdministratorConfig: BaseUserConfig = {
    baseConfig: baseConfig,
    roleInt: PortalUserRoles.LocalAdministrator,
    roleName: PortalUserRoles[PortalUserRoles.LocalAdministrator] as keyof typeof PortalUserRoles,
    routes: [],
    sections: [
        {
            id: ConfigSectionIds.BackupJobsComputersManagedByBackupServer,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.BackupJobsCloudDatabases,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
                vbServerName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.BackupJobsFileSharesLocal,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.BackupJobsFileSharesPublicClouds,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
                vbServerName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.BackupJobsVirtualMachinesPublicClouds,
            columns: {
                company: ConfigStates.Hidden,
                site: ConfigStates.Hidden,
                vbServerName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.BackupJobsVirtualMachinesVirtualInfrastructure,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.ProtectedDataCloudDatabases,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
                vbServerName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.ProtectedDataFileSharesLocal,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.ProtectedDataFileSharesPublicClouds,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
                vbServerName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.ProtectedDataVirtualMachinesVirtualInfrastructure,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
            },
        },
        {
            id: ConfigSectionIds.ProtectedDataVirtualMachinesPublicClouds,
            columns: {
                companyName: ConfigStates.Hidden,
                siteName: ConfigStates.Hidden,
                vbServerName: ConfigStates.Hidden,
            },
        },
    ],
};
